const ISSUE_META = [
  { key: "missingSku", label: "Missing SKU" },
  { key: "invalidPrice", label: "Invalid Price" },
  { key: "inactive", label: "Inactive Variant" },
];

export default function VariantIssuePanel({
  open,
  counts,
  activeFilters,
  onToggle,
  onSelectAll,
  onClear,
  onClose,
}) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-40">
      <div className="absolute inset-0 bg-black/20" onClick={onClose} />

      <aside className="absolute right-0 top-0 h-full w-full max-w-sm border-l border-zinc-200 bg-white p-4 shadow-xl dark:border-zinc-800 dark:bg-[#121214]">
        <div className="flex items-center justify-between">
          <h3 className="text-sm font-semibold text-zinc-900 dark:text-zinc-100">Issue Filters</h3>
          <button
            type="button"
            onClick={onClose}
            className="rounded-lg border border-zinc-200 px-2 py-1 text-xs dark:border-zinc-800"
          >
            Close
          </button>
        </div>

        <p className="mt-1 text-xs text-zinc-500 dark:text-zinc-400">
          Pick one or more issue types to focus the variant list.
        </p>

        <div className="mt-4 space-y-2">
          {ISSUE_META.map((issue) => {
            const checked = activeFilters.includes(issue.key);
            const count = counts[issue.key] || 0;
            return (
              <label
                key={issue.key}
                className="flex items-center justify-between rounded-xl border border-zinc-200 px-3 py-2 text-sm dark:border-zinc-800"
              >
                <div className="flex items-center gap-2">
                  <input
                    type="checkbox"
                    checked={checked}
                    onChange={() => onToggle(issue.key)}
                  />
                  <span>{issue.label}</span>
                </div>
                <span className="text-xs text-zinc-500 dark:text-zinc-400">{count}</span>
              </label>
            );
          })}
        </div>

        <div className="mt-4 flex gap-2">
          <button
            type="button"
            onClick={onSelectAll}
            className="rounded-xl border border-zinc-200 px-3 py-1.5 text-xs font-medium dark:border-zinc-800"
          >
            Select All
          </button>
          <button
            type="button"
            onClick={onClear}
            className="rounded-xl border border-zinc-200 px-3 py-1.5 text-xs font-medium dark:border-zinc-800"
          >
            Clear
          </button>
        </div>
      </aside>
    </div>
  );
}
